import { useTranslation } from "react-i18next";
import "./attendance.scss";
export default function AttendanceSummary({ event, summary }) {
  const { t } = useTranslation("ticketingDashboard");
  if (!event || !summary || !(Number(event.maxEntries) > 0)) return null;
  const maxEntries = Number(event.maxEntries);
  const inside = event.attendance?.version === 1 ? event.attendance.inside : summary.ticketsScanned;
  const stats = {
    inside,
    maxEntries,
    available: Math.max(0, maxEntries - inside),
    outside: Math.max(0, summary.ticketsDistributed - inside),
  };
  return (
    <section className="ticket-attendance" aria-label={t("attendance.title")} aria-live="polite">
      <h2 className="ticket-attendance__heading">{t("attendance.title")}</h2>
      <div className="amountContainer ticket-attendance__metrics">
        <div className="ticketsScanned">
          <p className="amount">
            {stats.inside} / {stats.maxEntries}
          </p>
          <p className="title">{t("attendance.inside")}</p>
        </div>
        <div className="theoreticalRevenue">
          <p className="amount">{stats.available}</p>
          <p className="title">{t("attendance.available")}</p>
        </div>
        <div className="ticketsDistributed">
          <p className="amount">{stats.outside}</p>
          <p className="title">{t("attendance.outside")}</p>
        </div>
      </div>
      <p className="ticket-attendance__hint">{t("attendance.outsideHelp")}</p>
    </section>
  );
}
